import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h14","key":"svg-0"}],["path",{"d":"M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 5l2 -2v6","key":"svg-2"}]]

const IconMath1Divide2 = createReactComponent('outline', 'math-1-divide-2', 'Math1Divide2', __iconNode);

export default IconMath1Divide2;